// extracted by mini-css-extract-plugin
module.exports = {"customScrollbar":"_2Tq8I","thumbVertical":"_1tRHq"};